export const GOOGLE_CLIENT_ID: string =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
// Space-delimited scopes per Google OAuth spec
export const GOOGLE_OAUTH_SCOPE = 'openid email profile';
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const BRAND_PRIMARY_COLOR = '#7f6aa0'; // primary-700 — use for non-Tailwind contexts (e.g. Razorpay theme)
export const ARROW_STROKE_COLOR = '#e5e7eb'; // gray-200 — use for SVG stroke props (e.g. FloatingArrow)
export const RAZORPAY_KEY_ID: string =
  process.env.REACT_APP_RAZORPAY_KEY_ID || '';
export const RAZORPAY_CHECKOUT_CONFIG_ID: string =
  process.env.REACT_APP_RAZORPAY_CHECKOUT_CONFIG_ID || '';
// Taskboard is still in build-out — hidden wherever REACT_APP_ENABLE_TASKBOARD
// is 'false' (production). Opt-out rather than opt-in so existing local/staging
// .env files keep working untouched.
export const TASKBOARD_ENABLED: boolean =
  process.env.REACT_APP_ENABLE_TASKBOARD !== 'false';
